module.exports = __webpack_public_path__ + "img/1440.1ce4472a.jpg";